import { RouterProvider } from "@tanstack/react-router"
import { NuqsAdapter } from "nuqs/adapters/react"

import { router } from "./router"
import { PWAInstallPrompt } from "./components/PWAInstallPrompt"

/**
 * Main App Component with TanStack Router.
 * NuqsAdapter provides URL-state management for nested routes.
 */
function App() {
  return (
    <NuqsAdapter>
      <RouterProvider router={router} />
      <PWAInstallPrompt />
    </NuqsAdapter>
  )
}

export default App
